import axios from 'axios';
import { FetchJornadaParams, GestionInfo, Horario, JornadaLaboral, ResponseRequestGeneric,TipoJornadaInfo} from 'components/Types/GeneralTypes';
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { authenticationService } from './authentication.service';
import {  RegistroEntradaSalida, RegistroJustificacion } from 'components/UsuarioGeneral/Registro Entrada Salida/typesRegistroEntradaSalida';
import configData from "config.json"
import { authHeaderWithToken } from "helpers/auth-header";
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

export const fetchJornadaLaboral = async (cedula): Promise<JornadaLaboral[]> => {
  try {
    const response = await axios.get<JornadaLaboral[]>(`${configData.MARCACIONES_URL}Jornada/GetJornadaLaboral/${cedula}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching jornada laboral:', error);
    return []; 
  }
};
export const fetchJornadaLaboralByMonth = async (cedula, month, anio): Promise<JornadaLaboral[]> => {
  try {
    const response = await axios.get<JornadaLaboral[]>(`${configData.MARCACIONES_URL}Jornada/GetInformacionJornadaMensual/${cedula}/${anio}/${month}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching jornada laboral:', error);
    return []; 
  }
};
export const fetchReminders = async (): Promise<GestionInfo[]> => {
  try {
    var userData: UserData = authenticationService.currentUserValue;
    var cedula = userData.identificacion;
    const response = await axios.get<GestionInfo[]>(`${configData.MARCACIONES_URL}Gestion/GetGestionesPersona/${cedula}`);
    return response.data;
  } catch (error) {
    console.error('Error reminders:', error);
    return []; 
  }
};
export const fetchNonWorkingDays = async (month): Promise<Date[]> => {
  try {
    var userData = authenticationService.currentUserValue; 
    var identification = userData.identificacion;
    const response = await axios.get(`${configData.MARCACIONES_URL}Jornada/GetNonWorkingDays?month=${month}&identification=${identification}`);
    return response.data.map(date => new Date(date));
  } catch (error) {
    console.error('Error fetching non-working days:', error);
    return [];
  }
};
export const fetchHolidays = async (): Promise<Date[]> => {
  try {
    var userData = authenticationService.currentUserValue; 
    var identification = userData.identificacion;
    const response = await axios.get(`${configData.MARCACIONES_URL}Jornada/GetNonWorkingDaysByDate/${identification}`);
    return response.data.map(date => new Date(date));
  } catch (error) {
    console.error('Error fetching non-working days:', error);
    return [];
  }
};
export const fetchMaxRecoveryDate = async (month):  Promise<Date> => {
  try {
    var userData = authenticationService.currentUserValue; 
    var identification = userData.identificacion;
    const response = await axios.get(`${configData.MARCACIONES_URL}Jornada/GetMaxRecoveryDate?month=${month}&identification=${identification}`);
    return new Date(`${response.data}T00:00:00`);
  } catch (error) {
    console.error('Error fetching non-working days:', error);
    throw new Error ('Error fetching maximum day');
  }
};

export const fetchScheduleByDate = async (fecha):  Promise<Horario> => {
  try {
    var userData = authenticationService.currentUserValue; 
    var identification = userData.identificacion;
    const response = await axios.get(`${configData.MARCACIONES_URL}Horario/GetHorarioEmpleado/Recuperacion?identificacion=${identification}&fecha=${fecha}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching schedule:', error);
    throw new Error ('Error fetching schedule');
  }
};
export const fetchJornadaLaboralDet = async (idJornada: number): Promise<JornadaLaboral> => {
  try {
    const response = await axios.get<JornadaLaboral>(`${configData.MARCACIONES_URL}Jornada/GetDetalleJornadaLaboral/${idJornada}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Aquí capturamos los errores específicos del HTTP status y reenviamos un mensaje personalizado
      if (error.response) {
        console.error('Error fetching jornada laboral:', error.response.status, error.response.data);
        throw new Error(`${error.response.data}` || 'Error desconocido');
      }
    }
    console.error('Error fetching jornada laboral:', error);
    throw new Error('Failed to fetch jornada laboral');
  }
};

export const  GetVistaPreviaFormularioJustificacion = async ( marcacion:RegistroJustificacion ) =>{
  var resultado: ResponseRequestGeneric<string> = { status: 200, dataResponse: "" };

  var userData: UserData = authenticationService.currentUserValue;
  var idpersona = userData.idpersona;
  marcacion.idpersona= idpersona;
  if(marcacion.tipo=="R"){
    var URL = `${configData.SERVER_URL}RegistroEntradaSalida/GetVistaPreviaRecuperacionPDF`;
  }else{
    var URL = `${configData.SERVER_URL}RegistroEntradaSalida/GetVistaPreviaJustificacionPDF`;
  }
  
  try {
      const respuesta = await axios.post(URL, marcacion,
          {
              headers: authHeaderWithToken(userData.token),
              responseType: "blob"
          }
      )
      const blob_resource = await respuesta.data;
      const url_documento = window.URL.createObjectURL(blob_resource);
      resultado = { status: respuesta.status, dataResponse: url_documento }
  } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
          var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();
          resultado = { status: error.response.status, errorMessage: mensaje }
      }
      else if (axios.isAxiosError(error) && !error.response) {
          resultado = { status: -1, errorMessage: "No ha sido posible contactar con el servidor. Intente más tarde." }
      }
  }
  return resultado;
}

export const  PostGuardarGestion = async ( marcacion:RegistroJustificacion ) =>{
  var resultado: ResponseRequestGeneric<string> = { status: 200, dataResponse: "" };

  var userData: UserData = authenticationService.currentUserValue;
  var idpersona = userData.idpersona;
  marcacion.idpersona= idpersona;
  var URL = `${configData.SERVER_URL}RegistroEntradaSalida/PostGuardarGestionWeb`;
  try {
      const respuesta = await axios.post(URL, marcacion,
          {
              headers: authHeaderWithToken(userData.token),
              responseType: "blob"
          }
      )
      const blob_resource = await respuesta.data;
      const url_documento = window.URL.createObjectURL(blob_resource);
      resultado = { status: respuesta.status, dataResponse: url_documento }
  } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
          var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

          resultado = { status: error.response.status, errorMessage: mensaje }
      }
      else if (axios.isAxiosError(error) && !error.response) {
          resultado = { status: -1, errorMessage: "No ha sido posible contactar con el servidor. Intente más tarde." }
      }
  }
  return resultado;
}

export const fetchIconColors = async (): Promise<TipoJornadaInfo[]> => {
  try {
      const response = await axios.get<TipoJornadaInfo[]>(`${configData.MARCACIONES_URL}Gestion/GetTipoJornadaInfo`);
      return response.data;
  } catch (error) {
      console.error('Failed to fetch icon colors:', error);
      return [];
  }
};

export const  getBorderColor = (tipo) => {
  switch (tipo) {
    case -1: return 'danger';
    case 0: return 'secondary';
    case 1: return 'success';
    case 2: return 'warning';
    case 3: return 'warning';
    case 4: return 'success';
  }
};
export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return format(date, 'dd/MM/yyyy', { locale: es });
};

export   const  getEventColor = (tipo) => {
  switch (tipo) {
      case -1: return '#ff4d4d'; // Color rojo, similar a 'danger'
      case 0: return '#6c757d'; // Color gris, similar a 'grey'
      case 1: return '#93D976'; // Color verde, similar a 'success'
      case 2: return '#ffc107'; // Color ámbar, similar a 'warning'
      default: return '#ffffff'; // Color blanco, similar a 'white'
  }
};
export function formatDateForEndpoint(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
export const formatDateForInput = (dateString) => {
  const date = new Date(dateString);
  return date.toISOString().split('T')[0]; 
};